import { render, staticRenderFns } from "./DatosLegalesShow.vue?vue&type=template&id=1402f5ef"
import script from "./DatosLegalesShow.vue?vue&type=script&lang=js"
export * from "./DatosLegalesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports